var videoLibrary={};
var categoryIndex=0;
videoLibrary.categories={};
videoLibrary.categories.title='<span>¿SABÍAS QUE UNA APLICACIÓN ADECUADA PUEDE</span> <h2>MAXIMIZAR LOS RESULTADOS?</h2>';
videoLibrary.categories.data=[];

// Category 1
//Category page related data
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="LIMPIADORES & TÓNICOS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/2979/7202/files/CLEANSERS_TONERS_Category_Cover.png?v=1678165562";
videoLibrary.categories.data[categoryIndex].description="Nuestras fórmulas de limpieza y tonificación, limpian la piel sin alterar el natural equilibrio del pH o humedad.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>CONOCE LOS BENEFICIOS DE</span><h2>LA TONIFICACIÓN</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/4ab92985c71747e4a1d014d35d0eb60c.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/2979/7202/files/Tonico_Thumbnail.png?v=1678166620";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/balancing-collagen-tonic');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/calming-collagen-tonic');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/revitalizing-collagen-tonic');

// Category 2
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="ELIXIRES & SUEROS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/2979/7202/files/elisar_img.png?v=1678165829";
videoLibrary.categories.data[categoryIndex].description="Aprende sobre los tratamientos de Haute que son la Joya de la Corona: sueros y elixires.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>CONOCE LOS BENEFICIOS DE</span><h2>ELIXIRES Y SERUMS</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/6da94f04c7964b24bf82fdaed23f048a.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/2979/7202/files/Elixirs_Thumbnail.png?v=1678168664";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/collections/post-medical-beauty');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/collections/elixir-treatments');


// Category 3
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="OJOS & LABIOS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/2979/7202/files/EYES_LIPS_Category_Cover.png?v=1678165953";
videoLibrary.categories.data[categoryIndex].description="Nuestro co-fundador Diego, te enseña cómo proporcionar hidratación, fuerza y ​​restauración a estas áreas.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>APRENDE ACERCA DE</span><h2>CONTORNO DE OJOS</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/ca8f511424d64da8a7025f43df6fbe92.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/2979/7202/files/Upper_Lid_Thumbnail.png?v=1678170251";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/eye-support-br-quench-restore-br-eye-serum-concentrate');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/eye-brighten-br-illuminate-lift-br-eye-serum-concentrate');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/upper-lid-and-contour-sublime-eye-balm');

// Category 4
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="HIDRATANTES & SOL";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/2979/7202/files/MOISTURIZERS_SUN_Category_Cover.png?v=1678166114";
videoLibrary.categories.data[categoryIndex].description="Tips profesionales de Diego para una hidratación suprema que te brindará  una piel verdaderamente sana y fresca, con un acabado natural.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>APRENDE SOBRE</span><h2>REAPLICACIÓN DE SPF</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/0d7c1897f9f34856873e45eee7698592.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/2979/7202/files/Radiance_Thumbnail.png?v=1678171599";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/radiance');







